// extracted by mini-css-extract-plugin
module.exports = {"notAvailable":"NotAvailable_notAvailable__km2Pl","recsPanelWrapper":"NotAvailable_recsPanelWrapper__ty4zU"};